var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5983 83.021L64.9865 58.3714C69.7612 52.3356 72.6137 44.7492 72.6137 36.4925C72.6137 16.9081 56.558 1 36.8249 1C17.0925 1 1 16.9254 1 36.5105C1 56.0949 17.0557 72.003 36.7888 72.003C44.8542 72.003 52.3031 69.3395 58.3064 64.8573L83.0256 89.5968C84.895 91.4677 87.7288 91.4677 89.5983 89.5968C91.4672 87.7263 91.4672 84.8918 89.5985 83.0213C89.5984 83.0212 89.5984 83.0211 89.5983 83.021ZM10.3942 36.5105C10.3942 22.1287 22.2352 10.4183 36.7888 10.4183C51.3424 10.4183 63.1834 22.1287 63.1834 36.5105C63.1834 50.8923 51.3424 62.6027 36.7888 62.6027C22.2356 62.6027 10.3942 50.8747 10.3942 36.5105Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.16243d095b70807f70fec018c394ab5a.svg";
export { ForwardRef as ReactComponent };